import { handleTrackLogoutEvent } from "../backend/tracking";

const SESSION_KEYS = ["idToken", "accessToken", "expirationDate", "refreshToken", "profile"];

export interface SessionTokens {
    idToken: string;
    accessToken?: string;
    refreshToken?: string;
    expiresIn?: number;
}

/**
 * The single writer for session tokens. Sign-in, the re-authentication modal and
 * the token refresh all persist the same keys in the same format.
 */
export function storeSession(result: SessionTokens) {
    localStorage.setItem("idToken", result.idToken);
    if (result.accessToken) {
        // Account-security calls need Cognito's access token, not the ID token.
        localStorage.setItem("accessToken", result.accessToken);
    }
    if (result.refreshToken) {
        localStorage.setItem("refreshToken", result.refreshToken);
    }
    if (result.expiresIn) {
        localStorage.setItem("expirationDate", new Date(new Date().getTime() + result.expiresIn * 1000).toString());
    }
}

/** Signs the user out locally: the one place that knows which keys make up a session. */
export function clearSession() {
    SESSION_KEYS.forEach(key => localStorage.removeItem(key));
    clearMfaPromptState();
    handleTrackLogoutEvent();
}

/**
 * The once-per-session enrollment prompt state. The durable per-user snooze in
 * localStorage deliberately survives a sign-out.
 */
export function clearMfaPromptState() {
    sessionStorage.removeItem("mfaPromptChecked");
    sessionStorage.removeItem("mfaPromptSnoozedUntil");
}

/**
 * Starts a step-up sign-in: the user comes back to `intendedPath` once the new
 * session carries two-step verification.
 */
export function signInAgain(intendedPath?: string) {
    sessionStorage.setItem("postMfaRedirect", intendedPath || "/projects");
    clearSession();

    (window as Window).location = "/auth/login";
}
